<button (click)="onClick.emit()"
	class="toggle-password-visibility-button"
	[goTooltip]="getTooltipText()"
	goTooltipPlacement="top"
	type="button"
	tabindex="-1">
	<mat-icon [ngClass]="{
		'ficon-app-preview-off': passwordHidden,
		'ficon-app-preview': !passwordHidden
	}">
	</mat-icon>
</button>
